exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NC6qaILF7dGKjb{display:flex}._3BasyIY9e1JK4h{align-items:center;display:flex;height:60px;margin:auto;width:60px}._3BasyIY9e1JK4h img{margin:auto;max-height:60px;max-width:60px}", ""]);

// exports
exports.locals = {
	"sectionHeaderWrapper": "NC6qaILF7dGKjb",
	"entLogo": "_3BasyIY9e1JK4h"
};